// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UjFh","footer":"styles_footer__2mDk2"};